import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/contactUs`

export const addContactUsApi = (formData) => {
  return axiosInstance.post(`${serverUrl}/insertContact`, formData)
}

export const getContactUsApi = () => {
  return axiosInstance.get(`${serverUrl}/getContact`)
}

export const updateContactUsApi = (id, formData) => {
  return axiosInstance.put(`${serverUrl}/updateById/${id}`, formData)
}

export const deleteContactUsApi = (id) => {
  return axiosInstance.delete(`${serverUrl}/delete/${id}`)
}

const ContactUsService = {
  addContactUs: addContactUsApi,
  getContactUss: getContactUsApi,
  updateContactUs: updateContactUsApi,
  deleteContactUs: deleteContactUsApi
}

export default ContactUsService

